import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import React from "react";
import { MenuItem } from "./config";

export interface MenuContextType {
  activeMenu?: MenuItem;
  setActiveMenu?: (menuName: ResourceCodeEnums) => void;
  /** 当前的菜单有没有数据权限 */
  hasPermission?: boolean;
  /** 当前的菜单有没有展示权限 */
  hasShowPermission?: boolean;
}

export const MenuContext = React.createContext<MenuContextType>({});
